import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-256ece22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref, reactive, onMounted, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { useRouter } from 'vue-router'
import { PermissionFe, ServicePermissionService } from '@/services/service-permission.service'
import WhiteList from '@/views/dashboard/data-safe/usb-manage/usb-policy/_components/white-list/white-list.vue'
import UsbPolicyEdit from '@/views/dashboard/data-safe/usb-manage/usb-policy-edit/usb-policy-edit.vue'
import { StrategyListData } from '@/views/dashboard/data-safe/usb-manage/usb-policy/usb-policy.service'
import PolicyManage from '@/views/dashboard/_components/policy-manage/policy-manage.vue'
import PageSubscribeBar from '@/views/dashboard/_components/subscribe-bar/page-subscribe-bar.vue'
import Card from '@/views/dashboard/_components/card/card.vue'
import StatisticsCards from './_components/statistics-cards.vue'
import PendingApprovalList from '@/views/dashboard/_components/pending-approval-list/pending-approval-list.vue'
import UsbAccessRankingChart from './_components/usb-access-ranking-chart.vue'
import UsbDeviceTypeDistributionChart from './_components/usb-device-type-distribution-chart.vue'
import { PolicySettingType, PolicyType } from '@/views/dashboard/_enum/policy-type'
import { TableOptColumn } from '@/components/cmTable/types'
import { FormSize, FormSizeType } from '@/components/cmForm/types'
import { TerminalType } from '@/views/dashboard/_enum/terminal-type'
import UnApproveViewService, { UnApproveItem, DeviceStatus } from '@/views/dashboard/data-safe/usb-manage/usb-approve/_components/unapprove-view/unapprove-view.service'
import UsbAccessEventList from './_components/usb-access-event-list/usb-access-event-list.vue'
import EquipmentList from './_components/equipment-list/equipment-list.vue'
import UsbTerminalAccessDrawerList from './_components/usb-terminal-access-drawer-list.vue'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import UsbStatisticsService from '@/views/dashboard/data-safe/usb-manage/usb-statistics/usb-statistics.service'
import TerminalViewService from '@/views/dashboard/data-safe/usb-manage/usb-statistics/_components/terminal-view/terminal-view.service'
import { ApprovalListService } from '@/views/dashboard/approval-center/service'
import { ApiApprovalTypeEnum, ApiApprovalStatusEnum } from '@/views/dashboard/approval-center/types'
import { ElMessage } from 'element-plus'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import type { UsbPolicyStatCardKey } from './_components/usb-policy-statistics-cards.types'

const USB_ACCESS_EVENT_TRIGGER_TIME_RANGE_LAST_MONTH = 4

interface UsbAccessRankingRow {
  name: string
  department: string
  count: number
  computer_name?: string
  user_mark?: string
  device_id?: string
}

interface PendingApprovalItem {
  id: string
  record_id: string
  peripheral_name: string
  group_name: string
  user_mark: string
  apply_time: number
  content?: string
  ext_info?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'usb-policy',
  setup(__props) {

const { t, locale } = useI18n()
const injector = useReflectiveInjector([UnApproveViewService, UsbStatisticsService, TerminalViewService, ApprovalListService])
const unApproveViewService = injector.get(UnApproveViewService)
const servicePermissionService = injector.get(ServicePermissionService)
const usbStatisticsService = injector.get(UsbStatisticsService)
const terminalViewService = injector.get(TerminalViewService)
const approvalListService = injector.get(ApprovalListService)
const router = useRouter()

const hasPermission = servicePermissionService.getHasPermission(PermissionFe.usb_peripheral_control)
const formSize: FormSizeType = FormSize.Small
const usbAccessEventListRef = ref()
const usbAccessRankingChartRef = ref()
const usbAccessEventDrawerVisible = ref(false)
/** 全量接入事件抽屉打开时预选的策略 id（「查看全部」为空；策略列表触发次数进入时为该策略） */
const usbAccessEventFullStrategyId = ref('')
/** 全量接入事件抽屉的记录时间 time_range（与 time 视图接口一致：4 = 近一个月） */
const usbAccessEventFullTimeRange = ref<number | undefined>(undefined)
/** 侧栏列表重挂载（切换带参 / 统计卡） */
const usbAccessEventDrawerKey = ref(0)
/** 从策略「触发次数」进入抽屉时固定为近一个月 */
const equipmentListDrawerVisible = ref(false)
const equipmentListPeripheralType = ref<number | undefined>(undefined)
const equipmentListChartTypeName = ref('')
const equipmentListDrawerHasContent = computed(
  () => equipmentListPeripheralType.value !== undefined
)
const equipmentListDrawerTitle = computed(() => {
  void locale.value
  const base = t('usbPolicy.equipmentTriggerRecords')
  if (
    equipmentListPeripheralType.value !== undefined &&
    equipmentListChartTypeName.value
  ) {
    return `${base} [${equipmentListChartTypeName.value}]`
  }
  return base
})

function openEquipmentListFromChart (payload: { peripheral_type: number; name: string }) {
  equipmentListPeripheralType.value = payload.peripheral_type
  equipmentListChartTypeName.value = payload.name
  equipmentListDrawerVisible.value = true
}

function onEquipmentListDrawerClosed () {
  equipmentListPeripheralType.value = undefined
  equipmentListChartTypeName.value = ''
}

/** 接入次数终端排行 → 侧栏终端列表（与 /peripheralcontrol/view/terminal/get 一致） */
const rankingTerminalDrawerVisible = ref(false)
const rankingTerminalDrawerKey = ref(0)
const rankingDrawerTimeRange = ref(1)
const rankingDrawerInitialSearchWord = ref('')

const rankingTerminalDrawerTitle = computed(() => {
  void locale.value
  const base = t('usbPolicy.accessRankTitle')
  const kw = rankingDrawerInitialSearchWord.value.trim()
  return kw ? `${base} — ${kw}` : base
})

function handleRankingRowClick (row: UsbAccessRankingRow) {
  if (Number(row.count) <= 0) return
  rankingDrawerTimeRange.value = rankingTimeRange.value
  rankingDrawerInitialSearchWord.value =
    (row.computer_name && String(row.computer_name).trim()) ||
    (row.user_mark && String(row.user_mark).trim()) ||
    ''
  rankingTerminalDrawerKey.value += 1
  rankingTerminalDrawerVisible.value = true
}

function onRankingTerminalDrawerClosed () {
  rankingDrawerInitialSearchWord.value = ''
}

// --- Statistics Data ---
const statistics = reactive({
  todayAccessCount: 0,
  pendingApprovals: 0,
  connectedDevices: 0
})

// --- Pending Approvals Data ---
// 使用审批中心的数据结构
const pendingApprovalsData = ref<PendingApprovalItem[]>([])

// --- Chart Data ---
const rankingTimeRange = ref(1)
const rankingData = ref<UsbAccessRankingRow[]>([])

const deviceTypeDistributionData = ref<Array<{ name: string; value: number; peripheral_type: number }>>([])


function viewAllUsbAccessEvents() {
  if (!hasPermission) return
  usbAccessEventFullStrategyId.value = ''
  usbAccessEventFullTimeRange.value = undefined
  usbAccessEventDrawerKey.value += 1
  usbAccessEventDrawerVisible.value = true
}

/** 统计卡：USB 接入事件 + 记录时间近 24h（与 time_range=2 一致） */
function handleUsbPolicyStatClick(key: UsbPolicyStatCardKey) {
  if (key === 'todayAccess' && statistics.todayAccessCount <= 0) return
  if (key === 'connectedDevices' && statistics.connectedDevices <= 0) return
  usbAccessEventFullStrategyId.value = ''
  usbAccessEventFullTimeRange.value = 2
  usbAccessEventDrawerKey.value += 1
  usbAccessEventDrawerVisible.value = true
}

// --- Policy Manage ---
const policyManageRef = ref()
const activeRow = ref({} as StrategyListData)
const whiteListVisible = ref(false)
const policyEditDrawerVisible = ref(false)
const policyEditPolicyId = ref('')

const customCols = computed<TableOptColumn[]>(() => [
  {
    label: t('usbPolicy.strategyMode'),
    prop: 'strategy.is_remind',
    columnOpt: { minWidth: 110, },
  },
  {
    label: t('usbPolicy.usbWhitelist'),
    prop: 'strategy.white_list',
    columnOpt: { minWidth: 110, },
  },
])

// --- Reject Dialog ---
const rejectDialogVisible = ref(false)
const currentRejectItem = ref<PendingApprovalItem | null>(null)
const rejectReason = ref('')

// --- Handlers ---
function showWhiteList(item: StrategyListData) {
  activeRow.value = item
  whiteListVisible.value = true
}

function triggerTimeCallback(item: StrategyListData) {
  usbAccessEventFullStrategyId.value = item.id || ''
  usbAccessEventFullTimeRange.value = USB_ACCESS_EVENT_TRIGGER_TIME_RANGE_LAST_MONTH
  usbAccessEventDrawerKey.value += 1
  usbAccessEventDrawerVisible.value = true
}

function handlePolicyAction({ type, rowItem }: { type: string; rowItem?: StrategyListData }) {
  if (type === 'add' || type === 'edit') {
    policyEditPolicyId.value = type === 'edit' ? rowItem?.id ?? '' : ''
    policyEditDrawerVisible.value = true
  }
}

function onPolicyEditSuccess() {
  policyEditDrawerVisible.value = false
  policyManageRef.value?.tableRef?.getList()
  loadStatistics()
}


function handleApprove(item: PendingApprovalItem) {
  approvalListService.getApprovalApprove({
    approval_type: ApiApprovalTypeEnum.Peripheral, // 外设控制
    record_id: item.record_id || item.id,
    is_agree: true,
    reason: '通过'
  }).then(() => {
    ElMessage.success(t('usbPolicy.approvalSuccess'))
    loadPendingApprovals()
    loadStatistics()
  }).catch((error) => {
    ElMessage.error(t('usbPolicy.approvalFailed'))
    console.error('审批失败:', error)
  })
}

function handleReject(item: PendingApprovalItem) {
  currentRejectItem.value = item as any
  rejectDialogVisible.value = true
}

function handleRejectConfirm() {
  if (!currentRejectItem.value) return
  if (!rejectReason.value.trim()) {
    ElMessage.warning(t('usbPolicy.pleaseRejectReason'))
    return
  }
  approvalListService.getApprovalApprove({
    approval_type: ApiApprovalTypeEnum.Peripheral, // 外设控制
    record_id: currentRejectItem.value.record_id || currentRejectItem.value.id,
    is_agree: false,
    reason: rejectReason.value
  }).then(() => {
    ElMessage.success(t('usbPolicy.rejectSuccess'))
    loadPendingApprovals()
    loadStatistics()
    rejectDialogVisible.value = false
    rejectReason.value = ''
    currentRejectItem.value = null
  }).catch((error) => {
    ElMessage.error(t('usbPolicy.rejectFailed'))
    console.error('拒绝失败:', error)
  })
}

function handleGoToApprovalCenter() {
  router.push('/dashboard/equipment-approve')
}

// 加载统计数据
async function loadStatistics() {
  if (!hasPermission) return

  try {
    const res = await usbStatisticsService.getPeripheralcontrolOverviewGet()

    // 更新统计卡片数据
    statistics.todayAccessCount = res.today_access_count || 0
    statistics.pendingApprovals = res.pending_approval_count || 0
    statistics.connectedDevices = res.connected_device_count || 0

    // 更新设备类型分布数据
    deviceTypeDistributionData.value = (res.list || []).map(item => ({
      name: item.type_name || t('usbPolicy.unknown'),
      value: item.count || 0,
      peripheral_type: item.peripheral_type
    }))
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载接入次数终端TOP5
async function loadRankingData() {
  if (!hasPermission) return

  if (usbAccessRankingChartRef.value) {
    usbAccessRankingChartRef.value.loading = true
  }
  try {
    const res = await terminalViewService.getTerminalList({
      page: 1,
      limit: 5,
      sort_key: 'access_count',
      asc: false,
      search_word: '',
      peripheral_status: 3, // 全部
      device_status: 3, // 全部
      time_range: rankingTimeRange.value
    })

    rankingData.value = (res.list || []).map(item => ({
      name: item.user_mark || item.computer_name || t('usbPolicy.unknown'),
      department: item.group_name || t('usbPolicy.unknown'),
      count: item.access_count || 0,
      computer_name: item.computer_name,
      user_mark: item.user_mark,
      device_id: item.device_id,
    }))
  } catch (error) {
    console.error('加载接入次数终端TOP5失败:', error)
  } finally {
    if (usbAccessRankingChartRef.value) {
      usbAccessRankingChartRef.value.loading = false
    }
  }
}

// 加载待审批列表
async function loadPendingApprovals() {
  if (!hasPermission) {
    pendingApprovalsData.value = []
    return
  }

  try {
    const res = await approvalListService.getApprovalList({
      approval_type: ApiApprovalTypeEnum.Peripheral, // 外设控制
      page_no: 1,
      page_size: 5,
      approval_status: ApiApprovalStatusEnum.Pending // 待审核
    })

    // 转换审批中心的数据格式
    pendingApprovalsData.value = (res.data || []).map(item => {
      let extInfo: any = {}
      try {
        extInfo = JSON.parse(item.ext_info || '{}')
      } catch (e) {
        console.error('解析 ext_info 失败:', e)
      }

      return {
        id: item.id,
        record_id: item.id,
        peripheral_name: extInfo.peripheral_name || item.content || t('usbPolicy.unknown'),
        group_name: item.group_name || t('usbPolicy.unknown'),
        user_mark: item.applicant || t('usbPolicy.unknown'),
        apply_time: typeof item.apply_time === 'string' ? parseInt(item.apply_time) : (item.apply_time || 0), // apply_time 是 Unix 时间戳（秒）
        content: item.content,
        ext_info: item.ext_info
      } as PendingApprovalItem
    })
  } catch (error) {
    console.error('加载待审批列表失败:', error)
  }
}

// 监听时间范围变化
watch(rankingTimeRange, () => {
  loadRankingData()
})

onMounted(() => {
  if (hasPermission) {
    loadStatistics()
    loadRankingData()
    loadPendingApprovals()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageSubscribeBar, {
      "normal-permission-key": _unref(PermissionFe).usb_peripheral_control
    }, null, 8, ["normal-permission-key"]),
    _createVNode(StatisticsCards, {
      "today-access-count": statistics.todayAccessCount,
      "pending-approvals": statistics.pendingApprovals,
      "connected-devices": statistics.connectedDevices,
      onStatClick: handleUsbPolicyStatClick
    }, null, 8, ["today-access-count", "pending-approvals", "connected-devices"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "cm-ui-mb16 charts-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withCtx(() => [
            _createVNode(PendingApprovalList, {
              list: pendingApprovalsData.value,
              "data-type": 'usb-peripheral',
              "approve-button-text": _ctx.$t('usbPolicy.agree'),
              "reject-button-text": _ctx.$t('usbPolicy.reject'),
              "approval-center-route": '/dashboard/approval-center?approvalType=' + _unref(ApiApprovalTypeEnum).Peripheral,
              onApprove: handleApprove,
              onReject: handleReject,
              onViewMore: handleGoToApprovalCenter
            }, null, 8, ["list", "approve-button-text", "reject-button-text", "approval-center-route"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(UsbAccessRankingChart, {
              ref_key: "usbAccessRankingChartRef",
              ref: usbAccessRankingChartRef,
              "time-range": rankingTimeRange.value,
              "onUpdate:timeRange": _cache[0] || (_cache[0] = ($event: any) => ((rankingTimeRange).value = $event)),
              data: rankingData.value,
              onRowClick: handleRankingRowClick
            }, null, 8, ["time-range", "data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(UsbDeviceTypeDistributionChart, {
              data: deviceTypeDistributionData.value,
              style: {"height":"100%"},
              onSliceClick: openEquipmentListFromChart
            }, null, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, {
      title: _ctx.$t('usbPolicy.usbAccessEventTitle'),
      size: "second",
      class: "cm-ui-mb16",
      onViewMore: viewAllUsbAccessEvents,
      "view-more-disabled": !_unref(hasPermission),
      "view-more-button-type": ""
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(UsbAccessEventList, {
          ref_key: "usbAccessEventListRef",
          ref: usbAccessEventListRef,
          "has-permission": _unref(hasPermission)
        }, null, 8, ["has-permission"])
      ]),
      _: 1
    }, 8, ["title", "view-more-disabled"]),
    _createVNode(_component_el_drawer, {
      size: "80%",
      title: _ctx.$t('usbPolicy.allUsbAccessEvents'),
      modelValue: usbAccessEventDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((usbAccessEventDrawerVisible).value = $event)),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(UsbAccessEventList, {
          key: usbAccessEventDrawerKey.value,
          viewMode: _unref(TableViewMode).full,
          "has-permission": _unref(hasPermission),
          "initial-strategy-id": usbAccessEventFullStrategyId.value,
          "initial-time-range": usbAccessEventFullTimeRange.value
        }, null, 8, ["viewMode", "has-permission", "initial-strategy-id", "initial-time-range"]))
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(PolicyManage, {
      title: _ctx.$t('usbPolicy.policyList'),
      ref_key: "policyManageRef",
      ref: policyManageRef,
      "normal-permission-key": _unref(PermissionFe).usb_peripheral_control,
      "strategy-type": _unref(PolicyType).usbControl,
      "data-type": _unref(PolicySettingType).usbControl,
      "custom-cols": customCols.value,
      "trigger-time-callback": triggerTimeCallback,
      "show-group-selector": true,
      "terminal-type": [_unref(TerminalType).windows, _unref(TerminalType).windowsServer],
      "edit-in-drawer": "",
      onHandleAction: handlePolicyAction
    }, {
      "table__strategy.is_remind": _withCtx(({ row }: { row?: StrategyListData }) => [
        (row && +row.strategy.control_type !== 2)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "--"))
          : row
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(row.strategy.is_remind ? _ctx.$t('usbPolicy.accessOnApply') : _ctx.$t('usbPolicy.noReadWrite')), 1))
            : _createCommentVNode("", true)
      ]),
      "table__strategy.white_list": _withCtx(({ row }: { row?: StrategyListData }) => [
        row
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              size: "mini",
              disabled: !row.strategy?.white_list?.length,
              type: "text",
              onClick: ($event: any) => (showWhiteList(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(row.strategy?.white_list?.length || 0), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "normal-permission-key", "strategy-type", "data-type", "custom-cols", "terminal-type"]),
    _createVNode(WhiteList, {
      modelValue: whiteListVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((whiteListVisible).value = $event)),
      "policy-name": activeRow.value.name,
      "white-list": activeRow.value.strategy?.white_list || []
    }, null, 8, ["modelValue", "policy-name", "white-list"]),
    _createVNode(_component_el_drawer, {
      modelValue: equipmentListDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((equipmentListDrawerVisible).value = $event)),
      title: equipmentListDrawerTitle.value,
      size: "80%",
      "destroy-on-close": "",
      direction: "rtl",
      onClosed: onEquipmentListDrawerClosed
    }, {
      default: _withCtx(() => [
        (equipmentListDrawerVisible.value && equipmentListDrawerHasContent.value)
          ? (_openBlock(), _createBlock(EquipmentList, {
              key: 0,
              "initial-peripheral-type": equipmentListPeripheralType.value,
              visible: equipmentListDrawerVisible.value,
              "has-permission": _unref(hasPermission)
            }, null, 8, ["initial-peripheral-type", "visible", "has-permission"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: rankingTerminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((rankingTerminalDrawerVisible).value = $event)),
      title: rankingTerminalDrawerTitle.value,
      size: "80%",
      "destroy-on-close": "",
      direction: "rtl",
      onClosed: onRankingTerminalDrawerClosed
    }, {
      default: _withCtx(() => [
        (rankingTerminalDrawerVisible.value)
          ? (_openBlock(), _createBlock(UsbTerminalAccessDrawerList, {
              key: rankingTerminalDrawerKey.value,
              "has-permission": _unref(hasPermission),
              "initial-time-range": rankingDrawerTimeRange.value,
              "initial-search-word": rankingDrawerInitialSearchWord.value
            }, null, 8, ["has-permission", "initial-time-range", "initial-search-word"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: policyEditDrawerVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((policyEditDrawerVisible).value = $event)),
      title: _ctx.$t('usbPolicy.strategyEdit'),
      size: "75%",
      "destroy-on-close": "",
      direction: "rtl"
    }, {
      default: _withCtx(() => [
        (policyEditDrawerVisible.value)
          ? (_openBlock(), _createBlock(UsbPolicyEdit, {
              key: 0,
              "drawer-mode": "",
              "initial-policy-id": policyEditPolicyId.value,
              onClose: _cache[5] || (_cache[5] = ($event: any) => (policyEditDrawerVisible.value = false)),
              onSuccess: onPolicyEditSuccess
            }, null, 8, ["initial-policy-id"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      top: "30vh",
      title: _ctx.$t('usbPolicy.rejectReasonTitle'),
      "destroy-on-close": "",
      modelValue: rejectDialogVisible.value,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((rejectDialogVisible).value = $event)),
      width: "470px"
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('usbPolicy.rejectReasonTitle')), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          size: "small",
          class: "dialog-button",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (rejectDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('usbPolicy.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "small",
          class: "dialog-button",
          type: "primary",
          onClick: handleRejectConfirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('usbPolicy.confirm')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          type: "textarea",
          placeholder: _ctx.$t('usbPolicy.rejectReasonPlaceholder'),
          modelValue: rejectReason.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((rejectReason).value = $event)),
          maxlength: "255",
          "show-word-limit": ""
        }, null, 8, ["placeholder", "modelValue"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})